<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

import BarChart from '@/components/Chart/Bar'
import LineChart from '@/components/Chart/Line'
import datePickerLang from '@/helpers/date-picker-lang'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import NumberInputSpinner from 'vue-number-input-spinner'
import DatePicker from 'vue2-datepicker'
import McDatePicker from '@/components/McDatePicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'
import draggable from 'vuedraggable'
moment.locale('id')

import ModalFleets from '../modalFleets'
import ModalGeofence from '../modalGeofence'

import { GET_FLEET_TOTALS_PER_DAY, GET_TOP_20_VEHICLES } from '@/services/api/dashboard/dashboard'
import { GET_DRIVER_SCORES } from '@/services/api/driverscore/score'
import { GET_COMPANY } from '@/services/api/master/companies'
import { GET_VEHICLE_STATUSES_FOR_DASHBOARD_CARD, GET_VEHICLE_IN_FENCE } from '@/services/api/fleet'
import { MixPanel } from '@/mixin/mixpanel'
import i18n from '@/i18n'
import ServiceScheduler from './maintenance/ServiceScheduler'
import LicenseReminder from '../components/LicenseReminder'
import { GET_VEHICLE_GROUPS } from '@/services/api/setting/fleet/fleetGroup'
import McAlert from '@/components/McAlert'

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    ModalFleets,
    ModalGeofence,

    BarChart,
    LineChart,
    DatePicker,
    McDatePicker,
    Multiselect,
    NumberInputSpinner,
    draggable,
    ServiceScheduler,
    LicenseReminder,
    McAlert,
  },
  mixins: [Helper, MixPanel],
  apollo: {
    driverScores: {
      query: GET_DRIVER_SCORES,
      manual: true,
      variables() {
        return {
          filter: {
            activeUser: true,
            orderBy: null,
            month: parseInt(moment().format('M')),
            year: parseInt(moment().format('YYYY')),
            pagination: {
              page: 1,
              show: 10,
            },
          },
        }
      },
      skip() {
        return !this.hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])
      },
      result({ data, loading }) {
        this.loadingDriverScores = loading
        if (loading) return
        this.totalDriverScores = data.driverScores.driverScores?.pagination.total
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },

    fleetTotals: {
      query: GET_FLEET_TOTALS_PER_DAY,
      variables() {
        let date = moment().format('YYYY-MM-DD')
        let last7day = moment().subtract(6, 'd').format('YYYY-MM-DD')
        return {
          input: {
            dateStart: last7day,
            dateEnd: date,
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.initFleetTotals(data)
        }
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },

    top20vehicles: {
      query: GET_TOP_20_VEHICLES,
      variables() {
        let date = moment().format('YYYY-MM-DD')
        let last7day = moment().subtract(6, 'd').format('YYYY-MM-DD')
        return {
          input: {
            dateStart: last7day,
            dateEnd: date,
            vgroupId: this.vgroupIdsFilter,
            disabledOdoFuel: this.hasAccess(['b1x-new-fuel-expectation:read']),
          },
        }
      },
      skip() {
        return !this.hasAccess([
          'top20vehicles_fuel:read',
          'top20vehicles_distance:read',
          'top20vehicles_duration:read',
          'top20vehicles_efficiency:read',
        ])
      },
      result({ _, loading }) {
        this.loadingTop20Vehicles = loading
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },

    company: {
      query: GET_COMPANY,
      variables() {
        return {
          filter: {
            id: this.getCompanyId(),
          },
        }
      },
    },

    vehiclesInFence: {
      client: 'clientLowPrio',
      query: GET_VEHICLE_IN_FENCE,
      manual: true,
      fetchPolicy: 'no-cache',
      variables() {
        const vgroupIdAllowed =
          this.$store.state.access.vGroups.map((x) => x.id).length > 0
            ? this.$store.state.access.vGroups.map((x) => x.id)
            : undefined
        const vgroupId =
          this.vgroupIdsFilter && vgroupIdAllowed ? this.vgroupIdsFilter : vgroupIdAllowed
        return {
          filter: {
            vgroupId: vgroupId,
          },
        }
      },
      skip() {
        return !this.hasAccessAll([
          'vehicles:read',
          'geofences:read',
          'a1f-dasbor-kendaraangeolokasi:read',
        ])
      },
      result({ data, loading }) {
        this.loadingVehicleInFence = loading
        if (data) {
          this.vehiclesInFence.vehiclesInFence = data.vehiclesInFence.vehiclesInFence.filter(
            (item) => item.geofence !== null
          )
          this.loadVehicleInFenceData()
        }
      },
    },

    vgroups: {
      query: GET_VEHICLE_GROUPS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.vehicleGroupLoading = false
        }
      },
    },
  },

  data() {
    return {
      form: {
        sector: null,
      },
      phaseOneShow: false,
      company: {
        company: {},
      },
      vehicleStatuses: {
        moving: [],
        idle: [],
        parking: [],
        assisted: [],
        offline: [],
      },
      modalVehicleStatus: false,
      vehicleStatusType: null,
      items: [],
      fleetTotals: {
        fleetTotals: [],
      },
      top20vehicles: {
        top20vehicles: [],
      },
      vehiclesInFence: {
        vehiclesInFence: [],
      },
      vehiclesInFenceOrder: [],
      modalGeofenceData: {
        label: null,
        data: [],
      },
      totalVehicleInGeofence: 0,
      driverScoresAsc: [],
      driverScoresDesc: [],
      driverAscending: [],
      driverDescending: [],
      firstRankDriver: { driver: {} },
      lastRankDriver: {},
      averageDriver: {
        score: 0,
        grade: '',
        total: 0,
      },

      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: 'spinner',
      color: '#007bff',
      bgColor: '#ffffff',
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      config: {},

      perulanganOtomatis: null,
      pengurutanData: null,
      perulanganData: null,

      refresh: false,

      showModalTotalJarakMengemudi: false,
      showModalJarakMengemudi: false,
      showModalTerbaik: false,
      showModalTerburuk: false,
      showModalSkorRata: false,
      showModalTotalBahanBakar: false,
      showModalBahanBakar: false,
      showModalDurasiMengemudi: false,
      showModalTotalDurasiMengemudi: false,
      showModalTidakEfisien: false,
      modalWidgetStatusKendaraan: false,
      modalWidgetTotalJarakMengemudi: false,
      modalWidgetJarakMengemudi: false,
      modalWidgetPengemudiTerbaik: false,
      modalWidgetPengemudiTerburuk: false,
      modalWidgetSkorRataRata: false,
      modalWidgetDurasiMengemudi: false,
      modalWidgetTotalDurasiMengemudi: false,
      modalWidgetTotalBahanBakar: false,
      modalWidgetBahanBakar: false,
      modalWidgetEstimasiBahanBakar: false,
      modalWidgetTidakEfisien: false,
      isOpenModalModalPool: false,
      defaultspinvalTerbaik: 1,
      selected: [],
      periode: [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      pembaruan: {
        key: '5',
        label: `5 ${this.$t('global.time.minutes')}`,
      },
      refreshInterval: '',
      gradeClass: {
        A: 'bg-success',
        B: 'bg-success',
        C: 'bg-warning',
        D: 'bg-danger',
        E: 'bg-danger',
        N: 'bg-secondary',
      },
      totalChartData: {
        distance: {
          labels: [],
          datasets: [],
        },
        minutes: {
          labels: [],
          datasets: [],
        },
        fuel: {
          labels: [],
          datasets: [],
        },
      },
      totalDriverScores: 0,

      layoutOrder: [
        { key: 'statistic', md: 12, sm: 12, order: 1 },
        { key: 'licenseReminder', md: 12, sm: 12, order: 2 },
        { key: 'topDistance', md: 8, sm: 12, order: 3 },
        { key: 'totalDistance', md: 4, sm: 12, order: 4 },
        { key: 'bestDriver', md: 4, sm: 12, order: 5 },
        { key: 'worstDriver', md: 4, sm: 12, order: 6 },
        { key: 'averageScore', md: 4, sm: 12, order: 7 },
        { key: 'topDuration', md: 8, sm: 12, order: 8 },
        { key: 'totalDuration', md: 4, sm: 12, order: 9 },
        { key: 'totalFuelUsage', md: 4, sm: 12, order: 10 },
        { key: 'fuelUsage', md: 8, sm: 12, order: 11 },
        { key: 'inefficientFuel', md: 12, sm: 12, order: 12 },
        { key: 'geofence', md: 12, sm: 12, order: 13 },
        { key: 'serviceScheduler', md: 4, sm: 12, order: 14 },
      ],

      isLayoutEdit: false,
      loading: true,
      loadingTotalsPerDay: true,
      loadingTop20Vehicles: true,
      loadingDriverScores: true,
      loadingVehicleStatuses: false,
      loadingVehicleInFence: true,
      language: i18n.locale,
      vgroups: {
        vgroups: [],
      },
      vehicleGroupFilter: [],
      vehicleGroupLoading: true,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),
    title() {
      return this.$t('menuitems.dashboards.text')
    },

    getTotalChartDataFuel() {
      return this.totalChartData.fuel
    },

    getTotalChartDataDistance() {
      return this.totalChartData.distance
    },

    getTotalChartDataMinutes() {
      return this.totalChartData.minutes
    },

    vgroupIdsFilter() {
      if (this.vehicleGroupFilter.length > 0) {
        return this.vehicleGroupFilter.map((item) => item.id)
      }
      return undefined
    },

    datePickerLang() {
      return datePickerLang()
    },

    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const dateStart = new Date()
            const dateEnd = new Date()
            dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
            dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
            dateStart.setHours(0, 0, 0, 0)
            dateEnd.setHours(23, 59, 59, 999)
            return [dateStart, dateEnd]
          },
        },
        {
          text: this.$t('global.time.last7Days'),
          onClick: () => {
            const date = new Date()
            date.setHours(0, 0, 0, 0)
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 6)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.last30Days'),
          onClick: () => {
            const date = new Date()
            date.setHours(0, 0, 0, 0)
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 29)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.thisMonth'),
          onClick: () => {
            const date = new Date()
            date.setHours(0, 0, 0, 0)
            date.setTime(date.getTime() - 3600 * 1000 * 24 * (date.getDate() - 1))
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.lastMonth'),
          onClick: () => {
            const awal = new Date()
            awal.setTime(awal.getTime() - 3600 * 1000 * 24 * awal.getDate())
            awal.setTime(awal.getTime() - 3600 * 1000 * 24 * (awal.getDate() - 1))

            const akhir = new Date()
            akhir.setTime(akhir.getTime() - 3600 * 1000 * 24 * akhir.getDate())

            return [awal, akhir]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },

    statData() {
      return [
        {
          icon: 'fas fa-route',
          title: this.$t('dashboard.info.moving'),
          value: '26',
        },
        {
          icon: 'fas fa-hourglass-start',
          title: this.$t('dashboard.info.stop'),
          value: '45',
        },
        {
          icon: 'fas fa-parking',
          title: this.$t('dashboard.info.parking'),
          value: '150',
        },
        {
          icon: 'fas fa-power-off',
          title: this.$t('dashboard.info.offline'),
          value: '23',
        },
      ]
    },

    distanceChartData() {
      if (this.top20vehicles.top20Vehicles === undefined) return { labels: [], datasets: [] }
      if (this.top20vehicles.top20Vehicles === null) return { labels: [], datasets: [] }
      let data = this.top20vehicles.top20Vehicles.filter(function (item) {
        return item.type == 'distance'
      })

      let labels = data.map((item) => item.licensePlate)
      let datas = data.map((item) => item.data)

      return {
        labels: labels,
        datasets: [
          {
            barPercentage: 0.4,
            label: this.$t('dashboard.chart.drivingDistance'),
            backgroundColor: '#0d4491',
            borderColor: '#0d4491',
            borderWidth: 1,
            hoverBackgroundColor: '#2c2c54',
            hoverBorderColor: '#2c2c54',
            data: datas,
          },
        ],
      }
    },

    minutesChartData() {
      if (this.top20vehicles.top20Vehicles === undefined) return { labels: [], datasets: [] }
      if (this.top20vehicles.top20Vehicles === null) return { labels: [], datasets: [] }
      let data = this.top20vehicles.top20Vehicles.filter(function (item) {
        return item.type == 'minutes'
      })

      let labels = data.map((item) => item.licensePlate)
      let datas = data.map((item) => item.data)

      return {
        labels: labels,
        datasets: [
          {
            barPercentage: 0.4,
            label: this.$t('dashboard.chart.drivingDuration'),
            backgroundColor: '#15621e',
            borderColor: '#15621e',
            borderWidth: 1,
            hoverBackgroundColor: '#2c2c54',
            hoverBorderColor: '#2c2c54',
            data: datas,
          },
        ],
      }
    },

    fuelChartData() {
      if (this.top20vehicles.top20Vehicles === undefined) return { labels: [], datasets: [] }
      if (this.top20vehicles.top20Vehicles === null) return { labels: [], datasets: [] }
      let data = this.top20vehicles.top20Vehicles?.filter(function (item) {
        return item.type == 'fuel'
      })

      let labels = data?.map((item) => item.licensePlate)
      let datas = data?.map((item) => item.data)

      return {
        labels: labels,
        datasets: [
          {
            barPercentage: 0.4,
            label: this.$t('dashboard.chart.fuelUse'),
            backgroundColor: '#f48421',
            borderColor: '#f48421',
            borderWidth: 1,
            hoverBackgroundColor: '#2c2c54',
            hoverBorderColor: '#2c2c54',
            data: datas,
          },
        ],
      }
    },

    efficiencyChartData() {
      if (this.top20vehicles.top20Vehicles === undefined) return { labels: [], datasets: [] }
      if (this.top20vehicles.top20Vehicles === null) return { labels: [], datasets: [] }
      let data = this.top20vehicles.top20Vehicles?.filter(function (item) {
        return item.type == 'efficiency'
      })

      let labels = data?.map((item) => item.licensePlate)
      let datas = data?.map((item) => item.data)

      this.customRefresh()

      return {
        labels: labels,
        datasets: [
          {
            barPercentage: 0.4,
            label: this.$t('dashboard.chart.fuelEfficiency'),
            backgroundColor: '#f71515',
            borderColor: '#f71515',
            borderWidth: 1,
            hoverBackgroundColor: '#2c2c54',
            hoverBorderColor: '#2c2c54',
            data: datas,
          },
        ],
      }
    },

    refreshTimeOption() {
      return [
        {
          key: 2,
          label: `${this.$t('dashboard.label.update')} 2 ${this.$t('global.time.minutes')}`,
        },
        {
          key: 5,
          label: `${this.$t('dashboard.label.update')} 5 ${this.$t('global.time.minutes')}`,
        },
        { key: 0, label: this.$t('dashboard.label.disable') },
      ]
    },

    optionMinutes() {
      return [
        `2 ${this.$t('global.time.minutes')}`,
        `5 ${this.$t('global.time.minutes')}`,
        `10 ${this.$t('global.time.minutes')}`,
      ]
    },

    optionFleetStatus() {
      return [
        this.$t('global.filter.running'),
        this.$t('global.filter.idle'),
        this.$t('global.filter.parking'),
        this.$t('global.filter.offline'),
      ]
    },

    optionSorting() {
      return [
        this.$t('global.option.biggest'),
        this.$t('global.option.smallest'),
        this.$t('global.option.licensePlateAsc'),
        this.$t('global.option.licensePlateDesc'),
      ]
    },

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },

    isHaveVehicleGroupFilterAccess() {
      return this.hasAccess(['a1h-dashboard-vgroupfilter:read'])
    },

    getVehicleGroupNames() {
      let vgroupNames = []
      if (this.vehicleGroupFilter.length > 0) {
        vgroupNames = this.vehicleGroupFilter.map((item) => item.name)
      }

      if (vgroupNames.length > 2) {
        return (
          vgroupNames.slice(0, 2).join(', ') +
          ` ${this.$t('global.and')} ${vgroupNames.length - 2} ${this.$t('global.others')}`
        )
      } else if (vgroupNames.length > 0) {
        return vgroupNames.join(', ')
      }

      return null
    },
  },

  watch: {
    vehicleGroupFilter() {
      this.refreshAll()
    },

    '$i18n.locale': function () {
      this.refresh = true

      moment.locale(i18n.locale)
      let key = 5
      let label = ''
      switch (this.pembaruan.key) {
        case 0:
          key = 0
          label = localStorage.getItem('language') === 'en' ? 'Disabled' : 'Nonaktif'
          break
        case 2:
          key = 2
          label = localStorage.getItem('language') === 'en' ? '2 Minutes' : '2 Menit'
          localStorage.removeItem('dashboard-config')
          break

        default:
          key = 5
          label = localStorage.getItem('language') === 'en' ? '5 Minutes' : '5 Menit'
          break
      }

      localStorage.removeItem('dashboard-config')

      setTimeout(() => {
        this.refresh = false
        this.changeRefreshTime({
          key: key,
          label: label,
        })
        this.config = JSON.parse(localStorage.getItem('dashboard-config'))
        this.pembaruan = this.config.refreshTime
        const data = {
          fleetTotals: this.fleetTotals,
        }
        this.initFleetTotals(data)
      }, 500)
    },
  },
  created() {
    i18n.locale = localStorage.getItem('language')
  },

  beforeMount() {
    const checkJustLogin = this.$route.query.isLoginSuccess
    if (checkJustLogin) {
      this.actionAfterLoginIdentity()
    }
  },

  mounted() {
    this.initDriverScore()
    this.config = JSON.parse(localStorage.getItem('dashboard-config'))

    if (!this.config) {
      localStorage.setItem(
        'dashboard-config',
        JSON.stringify({
          refreshTime: {
            key: 5,
            label: localStorage.getItem('language') === 'en' ? ' 5 Minutes' : '5 Menit',
          },
        })
      )
      this.config = JSON.parse(localStorage.getItem('dashboard-config'))
    }
    this.pembaruan = this.config.refreshTime
    this.refreshAll()

    let layoutOrder = JSON.parse(localStorage.getItem('dashboard-layout-latest-order'))
    if (layoutOrder) {
      this.layoutOrder = layoutOrder
    }

    this.$root.$on('bv::modal::hide', (bvEvent) => {
      if (bvEvent.componentId === 'modalFleets') {
        this.modalVehicleStatus = false
      }
    })
  },

  methods: {
    loadVehicleInFenceData() {
      const vehicleIds = []
      this.vehiclesInFence.vehiclesInFence.forEach((item) => {
        item.vgroup.forEach((vg) => {
          vg.vehicles.forEach((v) => {
            vehicleIds.push(v.vehicle.id)
          })
        })
      })
      this.totalVehicleInGeofence = [...new Set(vehicleIds)].length
      this.vehiclesInFenceOrder = [...this.vehiclesInFence.vehiclesInFence]
      this.vehiclesInFenceOrder?.sort((a, b) =>
        a.totalVehicle < b.totalVehicle ? 1 : b.totalVehicle < a.totalVehicle ? -1 : 0
      )
    },
    changeRefreshTime(data) {
      clearInterval(this.timer)
      let currentDate = moment().format('YYYY-MM-DD')

      if (data.key != 0 && currentDate >= this.periode[0] && currentDate <= this.periode[1]) {
        this.refreshAll()
      }
      localStorage.setItem('dashboard-config', JSON.stringify({ refreshTime: data }))
    },

    closeCalendar() {
      this.$refs.periodePicker.cancel()
    },

    async refreshAll() {
      this.loading = true
      await this.initVehicleStatuses()
      this.loadingTop20Vehicles = true
      await this.initTop20Vehicles()
      this.loadingTop20Vehicles = false
      this.loadingVehicleInFence = true
      await this.initVehiclesInFence()
      this.loading = false
      this.loadingVehicleInFence = false
      this.loadingDriverScores = true
      await this.initDriverScore()
      this.loadingDriverScores = false
      this.loadingTotalsPerDay = true
      await this.initFleetsTotal()
      this.loadingTotalsPerDay = false
      await this.$refs.serviceScheduler[0].loadServiceScheduler(this.vgroupIdsFilter)
      if (this.hasAccess(['dasbor_license:read'])) {
        await this.$refs.licenseReminderRef[0].initData()
      }
      // this.$store.dispatch('identity/init')
      if (this.pembaruan.key != 0) {
        this.refreshInterval = setInterval(() => {
          if (this.$route.path == '/') {
            this.initVehicleStatuses()
            this.initTop20Vehicles()
            this.initVehiclesInFence()
            this.initDriverScore()
            this.initFleetsTotal()
            if (this.hasAccess(['dasbor_license:read'])) {
              this.$refs.licenseReminderRef[0].initData()
            }
            // this.$store.dispatch('identity/init')
          } else {
            clearInterval(this.refreshInterval)
          }
        }, 60000 * Number(this.pembaruan.key))
      }
    },

    openModalModalPool(item) {
      this.isOpenModalModalPool = false
      let data = []
      item.vgroup.forEach((vg) => {
        vg.vehicles.forEach((vs) => {
          data.push({
            vehicleGroup: vg.name,
            timeInGeofence: this.minuteToTime(vs.timeInGeofence),
            licensePlate: vs.vehicle.licensePlate,
            id: vs.vehicle.id,
          })
        })
      })

      this.$nextTick()
      this.isOpenModalModalPool = true
      this.modalGeofenceData.label = item.geofence.fenceName
      this.modalGeofenceData.data = data
      this.modalGeofenceData.type = 'page'

      this.$nextTick(() => {
        this.$bvModal.show('modal-pool')
      })
    },

    openModalModalAllPool() {
      this.isOpenModalModalPool = false
      let data = []
      this.vehiclesInFenceOrder.forEach((row) => {
        row.vgroup.forEach((vg) => {
          vg.vehicles.forEach((vs) => {
            data.push({
              vehicleGroup: vg.name,
              timeInGeofence: row.geofence?.fenceName
                ? `${row.geofence?.fenceName} (${this.minuteToTime(vs.timeInGeofence)})`
                : '-',
              licensePlate: vs.vehicle.licensePlate,
              id: vs.vehicle.id,
            })
          })
        })
      })

      this.$nextTick()
      this.isOpenModalModalPool = true
      this.modalGeofenceData.label = null
      this.modalGeofenceData.data = data
      this.modalGeofenceData.type = 'all'

      this.$nextTick(() => {
        this.$bvModal.show('modal-pool')
      })
    },

    showDetailFleets(status) {
      this.items?.splice(0, this.items.length)
      this.track('View Fleet List on Dashboard Fleet Status', { status: status })

      if (status === 'moving') {
        this.items = [...this.vehicleStatuses.moving]
      } else if (status === 'idle') {
        this.items = [...this.vehicleStatuses.idle]
      } else if (status === 'parking') {
        this.items = [...this.vehicleStatuses.parking]
      } else if (status === 'assisted') {
        this.items = [...this.vehicleStatuses.assisted]
      } else if (status === 'offline') {
        this.items = [...this.vehicleStatuses.offline]
      }

      this.modalVehicleStatus = this.items.length ? true : false
      this.vehicleStatusType = status

      this.$nextTick(() => {
        if (this.modalVehicleStatus) {
          this.$bvModal.show('modalFleets')
        }
      })
    },

    changeDateRange() {
      if (
        !this.hasAccess([
          'top20vehicles_fuel:read',
          'top20vehicles_distance:read',
          'top20vehicles_duration:read',
          'top20vehicles_efficiency:read',
        ])
      )
        return

      this.$apollo.queries.top20vehicles.refetch({
        input: {
          dateStart: this.periode[0],
          dateEnd: this.periode[1],
        },
      })
    },

    customRefresh() {
      let currentDate = moment().format('YYYY-MM-DD')
      if (this.pembaruan.key != 0) {
        this.refreshInterval = setInterval(() => {
          if (this.$route.path == '/' && this.periode[1] == currentDate) {
            this.$apollo.queries.top20vehicles.refetch()
            this.$apollo.queries.vehiclesInFence.refetch()
          }
          clearInterval(this.refreshInterval)
        }, 60000 * Number(this.pembaruan.key))
      }
    },

    getDaysPeriode() {
      let startDate = moment().subtract(6, 'd')
      let endDate = moment()
      let now = startDate,
        dates = []
      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('YYYY-MM-DD'))
        now.add(1, 'days')
      }
      return dates
    },

    async initVehicleStatuses() {
      if (!this.hasAccessAll(['vehicle_statuses:read', 'a1a-dasbor-statuskendaraan:read'])) return
      this.loadingVehicleStatuses = true
      const self = this

      self.vehicleStatuses.moving = []
      self.vehicleStatuses.idle = []
      self.vehicleStatuses.parking = []
      self.vehicleStatuses.assisted = []
      self.vehicleStatuses.offline = []

      await this.$apollo
        .query({
          client: 'clientLowPrio',
          query: GET_VEHICLE_STATUSES_FOR_DASHBOARD_CARD,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              vehicleStatus: ['service', 'repair'],
              hasConnectedDevice: true,
              motionStatus: this.hasAccess(['assisted_motion_status:read'])
                ? ['assisted', 'idle', 'moving', 'offline', 'parking', 'unknown']
                : undefined,
              vgroupId: this.vgroupIdsFilter,
            },
          },
        })
        .then(({ data }) => {
          const vehiclesData = data.vehicleStatuses.vehicleStatuses
          self.$set(
            self.vehicleStatuses,
            'moving',
            vehiclesData?.filter((item) => item.calculatedMotionStatus == 'M')
          )
          self.$set(
            self.vehicleStatuses,
            'idle',
            vehiclesData?.filter((item) => item.calculatedMotionStatus == 'I')
          )
          self.$set(
            self.vehicleStatuses,
            'parking',
            vehiclesData?.filter((item) => item.calculatedMotionStatus == 'P')
          )
          self.$set(
            self.vehicleStatuses,
            'assisted',
            vehiclesData?.filter((item) => item.calculatedMotionStatus == 'A')
          )
          self.$set(
            self.vehicleStatuses,
            'offline',
            vehiclesData?.filter(
              (item) => item.calculatedMotionStatus == 'O' || item.calculatedMotionStatus == 'U'
            )
          )
          self.loadingVehicleStatuses = false
        })
    },

    async initTop20Vehicles() {
      if (
        !this.hasAccess(
          'top20vehicles_fuel:read',
          'top20vehicles_distance:read',
          'top20vehicles_duration:read',
          'top20vehicles_efficiency:read'
        )
      )
        return
      await this.$apollo.queries.top20vehicles.refetch()
    },

    async initFleetsTotal() {
      await this.$apollo.queries.fleetTotals.refetch()
    },

    async initVehiclesInFence() {
      if (
        !this.hasAccessAll([
          'vehicles:read',
          'geofences:read',
          'a1f-dasbor-kendaraangeolokasi:read',
        ])
      )
        return
      await this.$apollo.queries.vehiclesInFence.refetch()
    },

    async initDriverScore() {
      if (!this.hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])) return
      await this.$apollo.queries.driverScores
        .refetch({
          filter: {
            activeUser: true,
            month: parseInt(moment().format('M')),
            year: parseInt(moment().format('YYYY')),
            pagination: {
              page: 1,
              show: 5,
            },
            vgroupId: this.vgroupIdsFilter,
          },
        })
        .then((data) => {
          let score = data.data.driverScores.driverScores?.aggregation

          this.driverScoresAsc = score?.lowest10Drivers
          this.driverAscending = score?.lowest10Drivers?.slice(1, 5)
          this.lastRankDriver = score?.lowest10Drivers?.slice(0, 1)[0]
          this.driverScoresDesc = score?.top10Drivers
          this.driverDescending = score?.top10Drivers?.slice(1, 5)
          this.firstRankDriver = score?.top10Drivers?.slice(0, 1)[0]

          this.averageDriver = {
            score: score.averageScore ? parseFloat(score.averageScore).toFixed(2) : '-',
            grade: score.averageFinalGrade ? score.averageFinalGrade : 'N',
            total: score.totalDriver ? score.totalDriver : '-',
          }
        })
    },

    getGradeFromCompany(score) {
      let company = this.company.company
      if (score >= company?.dsMinScoreA) {
        return 'A'
      } else if (score < company?.dsMinScoreA && score >= company?.dsMinScoreB) {
        return 'B'
      } else if (score < company?.dsMinScoreB && score >= company?.dsMinScoreC) {
        return 'C'
      } else if (score < company?.dsMinScoreC && score >= company?.dsMinScoreD) {
        return 'D'
      } else {
        return 'E'
      }
    },

    initFleetTotals(data) {
      this.loadingTotalsPerDay = true

      if (
        data.fleetTotals.fleetTotals === undefined ||
        data.fleetTotals.fleetTotals == null ||
        data.fleetTotals.fleetTotals.length <= 0
      ) {
        this.totalChartData = {
          distance: {
            labels: [],
            datasets: [],
          },
          minutes: {
            labels: [],
            datasets: [],
          },
          fuel: {
            labels: [],
            datasets: [],
          },
        }
      }
      let dates = this.getDaysPeriode()
      let labels = []
      let dataDistance = []
      let dataFuel = []
      let dataMinutes = []

      for (let i = 0; i < dates.length; i++) {
        let dataPerDay = data.fleetTotals.fleetTotals?.filter(function (item) {
          let day = moment(item.day).format('YYYY-MM-DD')
          return day == dates[i]
        })

        labels.push(moment(dates[i]).format('ddd'))

        if (dataPerDay?.length > 0) {
          dataDistance.push(dataPerDay[0].totalDistance)
          dataFuel.push(dataPerDay[0].totalFuel)
          dataMinutes.push(dataPerDay[0].totalMinutes)
        } else {
          dataDistance.push(0)
          dataFuel.push(0)
          dataMinutes.push(0)
        }
      }

      let resDistance = {
        labels: labels,
        datasets: [
          {
            label: this.$t('dashboard.chart.totalDistance'),
            fill: true,
            lineTension: 0.5,
            backgroundColor: 'rgba(13, 68, 145, .2)',
            borderColor: '#0d4491',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#0d4491',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: '#0d4491',
            pointHoverBorderColor: '#fff',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: dataDistance,
          },
        ],
      }

      let resMinutes = {
        labels: labels,
        datasets: [
          {
            label: this.$t('dashboard.chart.totalDrivingDuration'),
            fill: true,
            lineTension: 0.5,
            backgroundColor: 'rgba(13, 68, 145, .2)',
            borderColor: '#15621e',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#15621e',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: '#15621e',
            pointHoverBorderColor: '#fff',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: dataMinutes,
          },
        ],
      }

      let resFuel = {
        labels: labels,
        datasets: [
          {
            label: this.$t('dashboard.chart.fuelUsage'),
            fill: true,
            lineTension: 0.5,
            backgroundColor: 'rgba(13, 68, 145, .2)',
            borderColor: '#f48421',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#f48421',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: '#f48421',
            pointHoverBorderColor: '#fff',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: dataFuel,
          },
        ],
      }

      this.totalChartData = {
        distance: resDistance,
        minutes: resMinutes,
        fuel: resFuel,
      }

      this.loadingTotalsPerDay = false
    },

    editLayout() {
      this.isLayoutEdit = true
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.add('mc-drag--dashboard')
      })
    },

    cancelEditLayout() {
      this.layoutOrder = this.layoutOrder.sort(function (a, b) {
        if (a.order < b.order) return -1
        if (a.order > b.order) return 1
        return 0
      })
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.remove('mc-drag--dashboard')
      })
      this.isLayoutEdit = false
    },

    saveLayout() {
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.remove('mc-drag--dashboard')
      })
      let newOrder = []
      this.layoutOrder.forEach(function (item, index) {
        newOrder.push({
          ...item,
          order: index + 1,
        })
      })

      this.layoutOrder = newOrder
      localStorage.setItem('dashboard-layout-latest-order', JSON.stringify(newOrder))
      this.isLayoutEdit = false
    },
  },
}
</script>

<template>
  <div class="mc-dashboard">
    <div class="row mb-3">
      <div class="col-md-12">
        <div
          :class="{
            'mc-table-filter': true,
            'd-flex': true,
            'align-items-center': true,
            'justify-content-space-between': vehicleGroupFilter.length > 0,
            'justify-content-end': vehicleGroupFilter.length <= 0,
          }"
        >
          <McAlert
            class="mc-alert-dashboard"
            v-if="vehicleGroupFilter.length > 0"
            variant="info"
            :html="
              $t('dashboard.text.vgroupFilterDesc', {
                vgroupNames: getVehicleGroupNames,
              })
            "
            withIcon
            :withGap="false"
          />
          <div class="mc-table-view ms-2" v-if="!isLayoutEdit">
            <div class="d-flex align-items-center">
              <span id="tooltip-info">
                <i class="mc-fa icon-outline_info"></i>
              </span>
              <multiselect
                v-model="pembaruan"
                :options="refreshTimeOption"
                track-by="key"
                label="label"
                @input="changeRefreshTime"
              />
            </div>
            <b-tooltip target="tooltip-info" triggers="hover" placement="topleft">
              <p v-if="pembaruan.key == 0">{{ $t('dashboard.text.noUpdate') }}</p>
              <p v-else>{{ $t('dashboard.text.updated') }} {{ pembaruan.label }}</p>
            </b-tooltip>
          </div>
          <mc-date-picker
            v-model="periode"
            :placeholder="$t('global.action.selectDate')"
            format="DD MMM YYYY"
            value-type="YYYY-MM-DD"
            :shortcuts="makeShortcuts"
            :draft="true"
            range-separator=" - "
            range
            @input="changeDateRange"
            :disabled="isLayoutEdit"
            :confirm="true"
            :confirm-text="$t('global.action.apply')"
            ref="periodePicker"
            :lang="datePickerLang"
          >
            <template #footer>
              <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">{{
                $t('global.action.cancel')
              }}</b-button>
            </template>
          </mc-date-picker>
          <div class="mc-table-view" v-if="isHaveVehicleGroupFilterAccess">
            <multiselect
              v-model="vehicleGroupFilter"
              :options="vgroups.vgroups"
              label="name"
              track-by="id"
              :placeholder="$t('report.fields.vehicleGroup')"
              :multiple="true"
              :loading="vehicleGroupLoading"
            >
              <template slot="selection" slot-scope="{ values, isOpen }">
                <div class="multiselect__tags-wrap" v-if="values.length && !isOpen">
                  <b-row>
                    <b-col md="9">
                      <span class="multiselect__tag">
                        <span>{{ values[0].name }}</span>
                        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
                      </span>
                    </b-col>
                    <b-col md="1">
                      <span
                        class="badge bg-success px-1 py-1 d-inline-block"
                        v-if="values.length > 1 && !isOpen"
                        >+{{ values.length - 1 }}</span
                      >
                    </b-col>
                  </b-row>
                </div>
              </template>
            </multiselect>
          </div>

          <b-button variant="outline-primary" class="me-2 ms-3" @click="refreshAll">
            <i class="mc-fa icon-fill_refresh"></i>
          </b-button>
          <a
            v-b-modal.modal-widget
            class="popup-form btn btn-outline-primary"
            href="javascript: void(0);"
            v-if="phaseOneShow"
          >
            <i class="mc-fa icon-outline_filter"></i> {{ $t('dashboard.object.widget') }}
          </a>
          <b-modal class="mc-modal" id="modal-widget" title="Widget" size="lg" centered scrollable>
            <div class="card-body mc-modal__filter border border-dark">
              <ul class="list-group">
                <simplebar>
                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('global.object.fleetStatus') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetStatusKendaraan = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetStatusKendaraan"
                          :title="$t('dashboard.title.fleetStatusConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="mc-modal__filter-item">
                                <b-form-group
                                  :label="$t('global.object.fleetStatus')"
                                  v-slot="{ ariaDescribedby }"
                                >
                                  <b-form-checkbox-group
                                    id="checkbox-group-1"
                                    v-model="selected"
                                    :options="optionFleetStatus"
                                    :aria-describedby="ariaDescribedby"
                                    name="flavour-1"
                                  ></b-form-checkbox-group>
                                </b-form-group>
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetStatusKendaraan = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.totalDistance') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetTotalJarakMengemudi = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetTotalJarakMengemudi"
                          :title="$t('dashboard.title.totalDistanceConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect
                                  v-model="pengurutanData"
                                  :options="['Terbaru', 'Terlama']"
                                />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetTotalJarakMengemudi = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.drivingDistance') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetJarakMengemudi = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetJarakMengemudi"
                          :title="$t('dashboard.title.distanceConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect v-model="pengurutanData" :options="optionSorting" />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetJarakMengemudi = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.status.bestDriver') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetPengemudiTerbaik = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetPengemudiTerbaik"
                          :title="$t('dashboard.title.bestDriverConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <p>{{ $t('dashboard.text.infoPeriod') }}</p>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetPengemudiTerbaik = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.status.worstDriver') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetPengemudiTerburuk = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetPengemudiTerburuk"
                          :title="$t('dashboard.title.worstDriverConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <p>{{ $t('dashboard.text.infoPeriod') }}</p>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetPengemudiTerburuk = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.label.averageScore') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetSkorRataRata = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetSkorRataRata"
                          :title="$t('dashboard.title.averageScoreConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <p>{{ $t('dashboard.text.infoPeriod') }}</p>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetSkorRataRata = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.drivingDuration') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetDurasiMengemudi = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetDurasiMengemudi"
                          :title="$t('dashboard.title.durationConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect v-model="pengurutanData" :options="optionSorting" />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetDurasiMengemudi = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.totalDrivingDuration') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetTotalDurasiMengemudi = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetTotalDurasiMengemudi"
                          :title="$t('dashboard.title.totalDurationConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect v-model="pengurutanData" :options="optionSorting" />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetTotalDurasiMengemudi = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.fuelUsage') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetTotalBahanBakar = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetTotalBahanBakar"
                          :title="$t('dashboard.title.totalFuelUsageConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect
                                  v-model="pengurutanData"
                                  :options="['Terbaru', 'Terlama']"
                                />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetTotalBahanBakar = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.fuelUse') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetBahanBakar = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetBahanBakar"
                          :title="$t('dashboard.title.fuelUsageConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect v-model="pengurutanData" :options="optionSorting" />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetBahanBakar = false"
                                >
                                  {{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.fuelEstimation') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetEstimasiBahanBakar = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetEstimasiBahanBakar"
                          :title="$t('dashboard.title.fuelEstimationConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect v-model="pengurutanData" :options="optionSorting" />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetEstimasiBahanBakar = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>

                  <b-col md="12" sm="12" class="mb-4">
                    <div class="p-2 form-control">
                      <div class="row">
                        <div class="col-sm-6">
                          <b-form-checkbox
                            value="accepted"
                            unchecked-value="not_accepted"
                            class="mb-1 mt-1"
                            checked
                            plain
                            >{{ $t('dashboard.chart.fuelEfficiency') }}</b-form-checkbox
                          >
                        </div>
                        <div class="col-sm-6">
                          <div class="text-sm-end mt-1">
                            <a
                              @click="modalWidgetTidakEfisien = true"
                              href="javascript: void(0);"
                              class="text-secondary"
                              ><i class="mc-fa icon-outline_settings"></i>
                              <span> {{ $t('global.object.configuration') }} </span></a
                            >
                          </div>
                        </div>

                        <b-modal
                          v-model="modalWidgetTidakEfisien"
                          :title="$t('dashboard.title.fuelEfficiencyUsageConfiguration')"
                          body-class="p-3"
                          hide-footer
                          size="md"
                        >
                          <form @submit.prevent="handleSubmit">
                            <div class="row">
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataAmount') }}</label>
                                <NumberInputSpinner
                                  :min="0"
                                  :max="10"
                                  :integerOnly="true"
                                  v-model="defaultspinvalTerbaik"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                                <multiselect
                                  v-model="perulanganOtomatis"
                                  :options="optionMinutes"
                                />
                              </div>
                              <div class="form-group mb-3">
                                <label>{{ $t('dashboard.label.dataSorting') }}</label>
                                <multiselect v-model="pengurutanData" :options="optionSorting" />
                              </div>
                              <div class="form-group">
                                <label>{{ $t('global.object.period') }}</label>
                                <date-picker
                                  v-model="periode"
                                  :placeholder="$t('global.action.selectDate')"
                                  format="DD MMMM YYYY"
                                  :shortcuts="makeShortcuts"
                                  range-separator=" - "
                                  range
                                  :lang="datePickerLang"
                                />
                              </div>
                            </div>

                            <div class="row mb-3 mt-4">
                              <b-col sm="12" md="6" class="mt-2">
                                <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                              </b-col>

                              <b-col sm="12" md="6" class="text-end">
                                <b-button
                                  variant="outline-primary"
                                  class="mx-2"
                                  @click="modalWidgetTidakEfisien = false"
                                  >{{ $t('global.action.cancel') }}</b-button
                                >
                                <b-button type="submit" variant="primary" class="ms-1">{{
                                  $t('global.action.apply')
                                }}</b-button>
                              </b-col>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </b-col>
                </simplebar>
              </ul>
            </div>
            <template #modal-footer="{ cancel }">
              <b-row class="mc-modal__filter-footer">
                <b-col sm="12" md="6" class="mc-modal__filter-footer-fav"> </b-col>

                <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
                  <b-button variant="outline-primary" @click="cancel()" class="me-3">
                    {{ $t('global.action.close') }}
                  </b-button>
                  <b-button variant="primary"> {{ $t('global.action.apply') }} </b-button>
                </b-col>
              </b-row>
            </template>
          </b-modal>
          <b-button
            variant="outline-primary"
            class="mc-ico ms-2"
            @click="editLayout"
            v-if="!isLayoutEdit"
          >
            <i class="mc-fa icon-outline_settings"></i>
          </b-button>
          <b-button
            variant="outline-danger"
            class="mc-ico mx-2"
            v-if="isLayoutEdit"
            @click="cancelEditLayout"
          >
            <i class="icon-outline_close"></i>
            {{ $t('global.action.cancel') }}
          </b-button>
          <b-button variant="success" class="mc-ico ms-2" v-if="isLayoutEdit" @click="saveLayout">
            <i class="icon-outline_checkmark"></i>
            {{ $t('global.action.apply') }}
          </b-button>
        </div>
      </div>
    </div>

    <draggable v-model="layoutOrder" class="row" draggable=".mc-drag--dashboard">
      <b-col
        v-for="layout in layoutOrder"
        :key="layout.key"
        :sm="layout.sm"
        :md="layout.md"
        class="drag-item"
      >
        <b-row class="mc-dashboard-card" v-if="layout.key == 'statistic'">
          <b-col
            class="mc-dashboard-card__item"
            v-show="hasAccessAll(['vehicle_statuses:read', 'a1a-dasbor-statuskendaraan:read'])"
          >
            <b-skeleton-wrapper :loading="loadingVehicleStatuses">
              <template #loading>
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton width="70%" />
                </b-card>
              </template>
              <div class="card mini-stats-wid" @click="showDetailFleets('moving')">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-9">
                      <p class="text-muted">{{ $t('dashboard.info.moving') }}</p>
                      <h5 class="font-size-13 mb-0">
                        {{ vehicleStatuses.moving.length }}
                      </h5>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title rounded-circle bg-success font-size-20">
                        <i class="icon-outline_truck-moving mc-fa"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </b-col>

          <b-col
            class="mc-dashboard-card__item"
            v-show="hasAccessAll(['vehicle_statuses:read', 'a1a-dasbor-statuskendaraan:read'])"
          >
            <b-skeleton-wrapper :loading="loadingVehicleStatuses">
              <template #loading>
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton width="70%" />
                </b-card>
              </template>
              <div class="card blog-stats-wid" @click="showDetailFleets('idle')">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-9">
                      <p class="text-muted">{{ $t('dashboard.info.stop') }}</p>
                      <h5 class="font-size-13 mb-0">
                        {{ vehicleStatuses.idle.length }}
                      </h5>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title rounded-circle bg-warning font-size-20">
                        <i class="icon-outline_truck-idle mc-fa"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </b-col>

          <b-col
            class="mc-dashboard-card__item"
            v-show="hasAccessAll(['vehicle_statuses:read', 'a1a-dasbor-statuskendaraan:read'])"
          >
            <b-skeleton-wrapper :loading="loadingVehicleStatuses">
              <template #loading>
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton width="70%" />
                </b-card>
              </template>
              <div class="card blog-stats-wid" @click="showDetailFleets('parking')">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-9">
                      <p class="text-muted">{{ $t('dashboard.info.parking') }}</p>
                      <h5 class="font-size-13 mb-0">
                        {{ vehicleStatuses.parking.length }}
                      </h5>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title rounded-circle bg-danger font-size-20">
                        <i class="icon-outline_truck-parking mc-fa"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </b-col>

          <b-col
            :class="{
              'mc-dashboard-card__item': true,
              'd-none': !hasAccess(['assisted_motion_status:read']),
            }"
            v-show="hasAccessAll(['vehicle_statuses:read', 'a1a-dasbor-statuskendaraan:read'])"
          >
            <b-skeleton-wrapper :loading="loadingVehicleStatuses">
              <template #loading>
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton width="70%" />
                </b-card>
              </template>
              <div class="card blog-stats-wid" @click="showDetailFleets('assisted')">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-9">
                      <p class="text-muted">{{ $t('dashboard.info.assisted') }}</p>
                      <h5 class="font-size-13 mb-0">
                        {{ vehicleStatuses.assisted.length }}
                      </h5>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title rounded-circle bg-info font-size-20">
                        <i class="icon-outline_truck-assisted mc-fa"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </b-col>

          <b-col
            class="mc-dashboard-card__item"
            v-show="hasAccessAll(['vehicle_statuses:read', 'a1a-dasbor-statuskendaraan:read'])"
          >
            <b-skeleton-wrapper :loading="loadingVehicleStatuses">
              <template #loading>
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton width="70%" />
                </b-card>
              </template>
              <div class="card blog-stats-wid" @click="showDetailFleets('offline')">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-9">
                      <p class="text-muted">{{ $t('dashboard.info.offline') }}</p>
                      <h5 class="font-size-13 mb-0">
                        {{ vehicleStatuses.offline.length }}
                      </h5>
                    </div>
                    <div class="avatar-sm">
                      <div class="avatar-title rounded-circle bg-secondary font-size-20">
                        <i class="icon-outline_truck-offline mc-fa"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </b-col>
        </b-row>
        <LicenseReminder
          v-if="layout.key == 'licenseReminder'"
          v-show="hasAccess(['dasbor_license:read'])"
          ref="licenseReminderRef"
        />
        <b-skeleton-wrapper
          v-if="layout.key == 'topDistance'"
          :loading="loadingTop20Vehicles"
          v-show="
            hasAccessAll(['top20vehicles_distance:read', 'a1b-dasbor-jarak&totalmengemudi:read'])
          "
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="
              hasAccessAll(['top20vehicles_distance:read', 'a1b-dasbor-jarak&totalmengemudi:read'])
            "
          >
            <div class="card-body">
              <div class="d-flex">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.chart.drivingDistance') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">
                    {{ $t('dashboard.topData.from') }} {{ momentDateShortMonth(periode[0]) }} -
                    {{ momentDateShortMonth(periode[1]) }}
                  </p>
                </div>
                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item href="#">{{ $t('global.object.period') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item href="#" @click="showModalJarakMengemudi = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    ></b-dropdown-item
                  >
                  <b-dropdown-item href="#"
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalJarakMengemudi"
                  :title="$t('dashboard.title.distanceConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataAmount') }}</label>
                        <NumberInputSpinner
                          :min="0"
                          :max="10"
                          :integerOnly="true"
                          v-model="defaultspinvalTerbaik"
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="optionSorting" />
                      </div>
                      <div class="form-group">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalJarakMengemudi = false"
                        >
                          {{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>
              <div v-if="!refresh" class="mc-chart">
                <BarChart
                  :labels="distanceChartData.labels"
                  :datasets="distanceChartData.datasets"
                  :yLabel="$t('dashboard.object.km')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <b-skeleton-wrapper
          v-if="layout.key == 'totalDistance'"
          :loading="loadingTotalsPerDay"
          v-show="
            hasAccessAll(['top20vehicles_distance:read', 'a1b-dasbor-jarak&totalmengemudi:read'])
          "
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="
              hasAccessAll(['top20vehicles_distance:read', 'a1b-dasbor-jarak&totalmengemudi:read'])
            "
          >
            <div class="card-body">
              <div class="d-flex">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.chart.totalDistance') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">{{ $t('global.time.last7Days') }}</p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item>{{ $t('global.time.today') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.yesterday') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.last7Days') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.thisMonth') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.last30Days') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item @click="showModalTotalJarakMengemudi = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalTotalJarakMengemudi"
                  :title="$t('dashboard.title.totalDistanceConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="['Terbaru', 'Terlama']" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalTotalJarakMengemudi = false"
                        >
                          {{ $t('global.action.cancel') }}</b-button
                        >
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>
              <div v-if="!refresh" class="mc-chart">
                <LineChart
                  :labels="getTotalChartDataDistance.labels"
                  :datasets="getTotalChartDataDistance.datasets"
                  :yLabel="$t('dashboard.chart.totalKm')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <b-skeleton-wrapper
          v-if="layout.key == 'topDuration'"
          :loading="loadingTop20Vehicles"
          v-show="
            hasAccessAll(['top20vehicles_duration:read', 'a1c-dasbor-durasi&totalmengemudi:read'])
          "
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="
              hasAccessAll(['top20vehicles_duration:read', 'a1c-dasbor-durasi&totalmengemudi:read'])
            "
          >
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.chart.drivingDuration') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">
                    {{ $t('dashboard.topData.from') }} {{ momentDateShortMonth(periode[0]) }} -
                    {{ momentDateShortMonth(periode[1]) }}
                  </p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item>{{ $t('global.object.period') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item @click="showModalDurasiMengemudi = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalDurasiMengemudi"
                  :title="$t('dashboard.title.durationConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataAmount') }}</label>
                        <NumberInputSpinner
                          :min="0"
                          :max="10"
                          :integerOnly="true"
                          v-model="defaultspinvalTerbaik"
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="optionSorting" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalDurasiMengemudi = false"
                        >
                          {{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div v-if="!refresh" class="mc-chart">
                <BarChart
                  :labels="minutesChartData.labels"
                  :datasets="minutesChartData.datasets"
                  :yLabel="$t('global.time.minutes')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <b-skeleton-wrapper
          v-if="layout.key == 'totalDuration'"
          :loading="loadingTotalsPerDay"
          v-show="
            hasAccessAll(['top20vehicles_duration:read', 'a1c-dasbor-durasi&totalmengemudi:read'])
          "
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="
              hasAccessAll(['top20vehicles_duration:read', 'a1c-dasbor-durasi&totalmengemudi:read'])
            "
          >
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.chart.totalDrivingDuration') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">{{ $t('global.time.last7Days') }}</p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item>{{ $t('global.time.today') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.yesterday') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.last7Days') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.thisMonth') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.last30Days') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item @click="showModalTotalDurasiMengemudi = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalTotalDurasiMengemudi"
                  :title="$t('dashboard.title.totalDurationConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="['Terbaru', 'Terlama']" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalTotalDurasiMengemudi = false"
                        >
                          {{ $t('global.action.cancel') }}</b-button
                        >
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div v-if="!refresh" class="mc-chart">
                <LineChart
                  :labels="getTotalChartDataMinutes.labels"
                  :datasets="getTotalChartDataMinutes.datasets"
                  :yLabel="$t('dashboard.chart.totalDuration')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <div
          class="mc-dashboard-driverscore"
          v-if="layout.key == 'bestDriver'"
          v-show="hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])"
        >
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.status.bestDriver') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">{{ $t('dashboard.topData.month') }}</p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item @click="showModalTerbaik = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalTerbaik"
                  :title="$t('dashboard.title.bestDriverConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <p>{{ $t('dashboard.text.infoPeriod') }}</p>

                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataAmount') }}</label>
                        <NumberInputSpinner
                          :min="0"
                          :max="10"
                          :integerOnly="true"
                          v-model="defaultspinvalTerbaik"
                        />
                      </div>
                      <div class="form-group">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="refreshTimeOption" />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalTerbaik = false"
                          >{{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div class="text-muted text-center mt-3" v-if="driverScoresDesc.length > 0">
                <i class="mc-fa icon-outline_person-add fa-5x text-primary"></i>
                <h6 class="teal-400 font-size-13">
                  {{ firstRankDriver.driver ? firstRankDriver.driver.fullname : '' }}
                  <span
                    class="badge rounded-pill font-size-14 mx-2"
                    :class="gradeClass[firstRankDriver.finalGrade]"
                    >{{
                      firstRankDriver.finalGrade == 'N' ? '-' : firstRankDriver.finalGrade
                    }}</span
                  >
                  {{ parseFloat(firstRankDriver.score).toFixed(2) ?? '-' }}
                </h6>
              </div>

              <div
                data-simplebar
                class="mc-dashboard-driverscore__data"
                v-if="driverScoresDesc.length > 0"
              >
                <ul class="list-group list-group-flush">
                  <li
                    class="list-group-item py-2"
                    v-for="(driver, index) in driverDescending"
                    :key="index"
                  >
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-2">
                        <div class="avatar-title rounded-circle bg-light text-primary">
                          <i class="mc-fa icon-outline_person"></i>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <div class="row align-items-center">
                          <div
                            class="col-md-6 col-6"
                            v-b-tooltip.hover="driver.driver ? driver.driver.fullname : ''"
                          >
                            <p class="font-size-13 teal-400 mb-1 mt-2 limited-text">
                              {{ driver.driver ? driver.driver.fullname : '' }}
                            </p>
                          </div>
                          <div class="col-md-6 col-6 text-end">
                            <h6>
                              <span
                                class="badge rounded-pill font-size-14 mt-2 mx-2"
                                :class="gradeClass[driver.finalGrade]"
                                >{{ driver.finalGrade == 'N' ? '-' : driver.finalGrade }}</span
                              >
                              <b>{{ parseFloat(driver.score).toFixed(2) ?? '-' }}</b>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="mc-dashboard-driverscore__data-more">
                  <a
                    href="javascript: void(0);"
                    class="btn btn-primary"
                    @click="$router.push({ name: 'List Driver Score V2' })"
                  >
                    {{ $t('global.action.seeMore') }}
                  </a>
                </div>
              </div>

              <div class="text-muted text-center mt-4 py-68" v-if="driverScoresDesc.length == 0">
                <p class="mt-3">{{ $t('global.text.noData') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mc-dashboard-driverscore"
          v-if="layout.key == 'worstDriver'"
          v-show="hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])"
        >
          <div class="card">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.status.worstDriver') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">{{ $t('dashboard.topData.month') }}</p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item @click="showModalTerburuk = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalTerburuk"
                  :title="$t('dashboard.title.worstDriverConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <p>{{ $t('dashboard.text.infoPeriod') }}</p>

                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataAmount') }}</label>
                        <NumberInputSpinner
                          :min="0"
                          :max="10"
                          :integerOnly="true"
                          v-model="defaultspinvalTerbaik"
                        />
                      </div>
                      <div class="form-group">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalTerburuk = false"
                          >{{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div class="text-muted text-center mt-3" v-if="driverScoresAsc.length > 0">
                <i class="mc-fa icon-outline_person-remove fa-5x text-danger"></i>
                <h6 class="teal-400 font-size-13">
                  {{ lastRankDriver.driver ? lastRankDriver.driver.fullname : '' }}
                  <span
                    class="badge rounded-pill font-size-14 mx-2"
                    :class="gradeClass[lastRankDriver.finalGrade]"
                    >{{ lastRankDriver.finalGrade == 'N' ? '-' : lastRankDriver.finalGrade }}</span
                  >
                  {{ parseFloat(lastRankDriver.score).toFixed(2) ?? '-' }}
                </h6>
              </div>

              <div
                data-simplebar
                class="mc-dashboard-driverscore__data"
                v-if="driverScoresAsc.length > 0"
              >
                <ul class="list-group list-group-flush">
                  <li
                    class="list-group-item py-2"
                    v-for="(driver, index) in driverAscending"
                    :key="index"
                  >
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-2">
                        <div class="avatar-title rounded-circle bg-light text-primary font-size-16">
                          <i class="mc-fa icon-outline_person"></i>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <div class="row align-items-center">
                          <div
                            class="col-md-6 col-6"
                            v-b-tooltip.hover="driver.driver ? driver.driver.fullname : ''"
                          >
                            <p class="font-size-13 teal-400 mb-1 mt-2 limited-text">
                              {{ driver.driver ? driver.driver.fullname : '' }}
                            </p>
                          </div>
                          <div class="col-md-6 col-6 text-end">
                            <h6>
                              <span
                                class="badge rounded-pill font-size-14 mt-2 mx-2"
                                :class="gradeClass[driver.finalGrade]"
                                >{{ driver.finalGrade == 'N' ? '-' : driver.finalGrade }}</span
                              >
                              <b>{{ parseFloat(driver.score).toFixed(2) ?? '-' }}</b>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="mc-dashboard-driverscore__data-more">
                  <a
                    href="javascript: void(0);"
                    class="btn btn-primary"
                    @click="$router.push({ name: 'List Driver Score V2' })"
                  >
                    {{ $t('global.action.seeMore') }}
                  </a>
                </div>
              </div>

              <div class="text-muted text-center mt-4 py-68" v-if="driverScoresAsc.length == 0">
                <p class="mt-3">{{ $t('global.text.noData') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mc-dashboard-driverscore"
          v-if="layout.key == 'averageScore'"
          v-show="hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])"
        >
          <div class="card">
            <div class="card-body mb-2">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.label.averageScore') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">{{ $t('global.time.thisMonth') }}</p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item @click="showModalSkorRata = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalSkorRata"
                  :title="$t('dashboard.title.averageScoreConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <p>{{ $t('dashboard.text.infoPeriod') }}</p>

                      <div class="form-group">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalSkorRata = false"
                          >{{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div class="text-muted text-center mt-4 py-68" v-if="driverScoresDesc.length > 0">
                <h1 class="text-dark">
                  <strong>{{ averageDriver.score }}</strong>
                </h1>
                <span
                  class="badge rounded-pill font-size-24"
                  :class="gradeClass[averageDriver.grade]"
                  >{{ averageDriver.grade == 'N' ? '-' : averageDriver.grade }}</span
                >
                <p class="mt-4 teal-400">
                  {{ $t('dashboard.text.averageScore') }}
                  <b>{{ averageDriver.total }}</b> {{ $t('dashboard.text.driver') }}
                </p>
              </div>

              <div class="teal-400 text-center mt-4 py-68" v-if="driverScoresDesc.length == 0">
                <p class="mt-3">{{ $t('global.text.noData') }}</p>
              </div>
            </div>
          </div>
        </div>

        <b-skeleton-wrapper
          v-if="layout.key == 'totalFuelUsage'"
          :loading="loadingTotalsPerDay"
          v-show="hasAccessAll(['top20vehicles_fuel:read', 'a1d-dasbor-bahanbakar:read'])"
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="hasAccessAll(['top20vehicles_fuel:read', 'a1d-dasbor-bahanbakar:read'])"
          >
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.chart.fuelUsage') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">{{ $t('global.time.last7Days') }}</p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item>{{ $t('global.time.today') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.yesterday') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.last7Days') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.thisMonth') }}</b-dropdown-item>
                  <b-dropdown-item>{{ $t('global.time.last30Days') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item @click="showModalTotalBahanBakar = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalTotalBahanBakar"
                  :title="$t('dashboard.title.totalFuelUsageConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="['Terbaru', 'Terlama']" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalTotalBahanBakar = false"
                        >
                          {{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div v-if="!refresh" class="mc-chart">
                <LineChart
                  :labels="getTotalChartDataFuel.labels"
                  :datasets="getTotalChartDataFuel.datasets"
                  :yLabel="$t('dashboard.chart.totalUsage')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <b-skeleton-wrapper
          :loading="loadingTop20Vehicles"
          v-if="layout.key == 'inefficientFuel'"
          v-show="hasAccessAll(['top20vehicles_fuel:read', 'a1d-dasbor-bahanbakar:read'])"
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="hasAccessAll(['top20vehicles_fuel:read', 'a1d-dasbor-bahanbakar:read'])"
          >
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">
                    {{ $t('dashboard.chart.fuelEfficiency') }}
                  </h5>
                  <p class="font-size-10 teal-200 mb-0">
                    {{ $t('dashboard.topData.from') }} {{ momentDateShortMonth(periode[0]) }} -
                    {{ momentDateShortMonth(periode[1]) }}
                  </p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item>{{ $t('global.object.period') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item @click="showModalTidakEfisien = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalTidakEfisien"
                  :title="$t('dashboard.title.fuelEfficiencyUsage')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataAmount') }}</label>
                        <NumberInputSpinner
                          :min="0"
                          :max="10"
                          :integerOnly="true"
                          v-model="defaultspinvalTerbaik"
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="optionSorting" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalTidakEfisien = false"
                          >{{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div v-if="!refresh" class="mc-chart">
                <BarChart
                  :labels="efficiencyChartData.labels"
                  :datasets="efficiencyChartData.datasets"
                  :yLabel="$t('dashboard.object.kmPerLiter')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <b-skeleton-wrapper
          :loading="loadingTop20Vehicles"
          v-if="layout.key == 'fuelUsage'"
          v-show="hasAccessAll(['top20vehicles_fuel:read', 'a1d-dasbor-bahanbakar:read'])"
        >
          <template #loading>
            <b-card>
              <b-skeleton width="85%" />
              <b-skeleton width="55%" />
              <b-skeleton width="60%" />
              <b-skeleton-img no-aspect height="430px" class="mt-3" />
            </b-card>
          </template>
          <div
            class="card"
            v-show="hasAccessAll(['top20vehicles_fuel:read', 'a1d-dasbor-bahanbakar:read'])"
          >
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <h5 class="font-size-13 teal-400 mb-1">{{ $t('dashboard.chart.fuelUse') }}</h5>
                  <p class="font-size-10 teal-200 mb-0">
                    {{ $t('dashboard.topData.from') }} {{ momentDateShortMonth(periode[0]) }} -
                    {{ momentDateShortMonth(periode[1]) }}
                  </p>
                </div>

                <b-dropdown
                  text="Button text via Prop"
                  toggle-tag="a"
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
                  toggle-class="font-size-16 p-0"
                  variant="white"
                  right
                  v-if="phaseOneShow"
                >
                  <template #button-content>
                    <i class="mdi mdi-dots-vertical"></i>
                  </template>
                  <b-dropdown-item>{{ $t('global.object.period') }}</b-dropdown-item>
                  <hr />
                  <b-dropdown-item @click="showModalBahanBakar = true"
                    ><i class="mc-fa icon-outline_settings">
                      {{ $t('global.object.configuration') }}</i
                    >
                  </b-dropdown-item>
                  <b-dropdown-item
                    ><i class="mc-fa icon-outline_eye-off">
                      {{ $t('global.action.hide') }}</i
                    ></b-dropdown-item
                  >
                </b-dropdown>

                <b-modal
                  v-model="showModalBahanBakar"
                  :title="$t('dashboard.title.fuelUsageConfiguration')"
                  body-class="p-3"
                  hide-footer
                  size="md"
                >
                  <form @submit.prevent="handleSubmit">
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataAmount') }}</label>
                        <NumberInputSpinner
                          :min="0"
                          :max="10"
                          :integerOnly="true"
                          v-model="defaultspinvalTerbaik"
                        />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.automaticLoop') }}</label>
                        <multiselect v-model="perulanganOtomatis" :options="optionMinutes" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('dashboard.label.dataSorting') }}</label>
                        <multiselect v-model="pengurutanData" :options="optionSorting" />
                      </div>
                      <div class="form-group mb-3">
                        <label>{{ $t('global.object.period') }}</label>
                        <date-picker
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMMM YYYY"
                          :shortcuts="makeShortcuts"
                          range-separator=" - "
                          range
                          :lang="datePickerLang"
                        />
                      </div>
                    </div>

                    <div class="row mb-3 mt-4">
                      <b-col sm="12" md="6" class="mt-2">
                        <h6 class="text-primary">{{ $t('global.action.reset') }}</h6>
                      </b-col>

                      <b-col sm="12" md="6" class="text-end">
                        <b-button
                          variant="outline-primary"
                          class="mx-2"
                          @click="showModalBahanBakar = false"
                          >{{ $t('global.action.cancel') }}
                        </b-button>
                        <b-button type="submit" variant="primary" class="ms-1">{{
                          $t('global.action.apply')
                        }}</b-button>
                      </b-col>
                    </div>
                  </form>
                </b-modal>
              </div>

              <div v-if="!refresh" class="mc-chart">
                <BarChart
                  :labels="fuelChartData.labels"
                  :datasets="fuelChartData.datasets"
                  :yLabel="$t('dashboard.object.liter')"
                />
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <b-skeleton-wrapper
          :loading="loadingVehicleInFence"
          v-if="layout.key == 'geofence'"
          v-show="
            hasAccessAll(['vehicles:read', 'geofences:read', 'a1f-dasbor-kendaraangeolokasi:read'])
          "
        >
          <template #loading>
            <b-row>
              <b-col md="4">
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton-img no-aspect height="430px" class="mt-3" />
                </b-card>
              </b-col>
              <b-col md="8">
                <b-card>
                  <b-skeleton width="85%" />
                  <b-skeleton width="55%" />
                  <b-skeleton-img no-aspect height="430px" class="mt-3" />
                </b-card>
              </b-col>
            </b-row>
          </template>
          <div
            class="mc-dashboard-geofence"
            v-show="
              hasAccessAll([
                'vehicles:read',
                'geofences:read',
                'a1f-dasbor-kendaraangeolokasi:read',
              ])
            "
          >
            <b-row>
              <b-col md="4">
                <div class="mc-dashboard-geofence__total">
                  <i class="mc-fa icon-outline_pin"></i>
                  <div class="d-flex flex-wrap">
                    <div>
                      <h5 class="font-size-13 teal-400 mb-1 text-white">
                        {{ $t('dashboard.text.fleetInGeolocation') }}
                      </h5>
                      <p class="mb-0 font-size-10">
                        {{ momentDateLongMonth() }} {{ $t('global.time.today') }}
                      </p>
                    </div>
                  </div>
                  <div class="mc-dashboard-geofence__total-wrapper">
                    <h2>{{ totalVehicleInGeofence }}</h2>
                    <p class="font-size-16">
                      {{ $t('dashboard.chart.totalFleetInGeolocation') }}
                    </p>
                    <b-button variant="primary" @click="openModalModalAllPool()">{{
                      $t('dashboard.action.viewAll')
                    }}</b-button>
                  </div>
                </div>
              </b-col>
              <b-col md="8">
                <div class="mc-dashboard-geofence__list">
                  <div class="d-flex flex-wrap">
                    <div>
                      <h5 class="font-size-13 teal-400 mb-1">
                        {{ $t('dashboard.title.denseGeolocation') }}
                      </h5>
                      <p class="font-size-10 teal-200 mb-0">
                        {{ $t('dashboard.text.mostPopulous') }}
                      </p>
                    </div>
                  </div>
                  <div class="mc-dashboard-geofence__list-wrapper">
                    <div v-if="vehiclesInFenceOrder.length == 0" class="mc-nodata__section">
                      <figure class="mc-nodata__section-figure">
                        <img :src="illustrationPath" alt />
                      </figure>
                      <p class="mc-nodata__section-text">
                        {{ $t('dashboard.text.noFleetInGeolocation') }}
                      </p>
                    </div>
                    <div v-else>
                      <span v-for="(row, index) in vehiclesInFenceOrder" :key="index">
                        <div
                          class="d-flex justify-content-between mc-dashboard-geofence__list-item"
                          v-if="index < 10"
                          @click="openModalModalPool(row)"
                        >
                          <h5>
                            <i class="mc-fa icon-outline_pin"></i>
                            {{ row.geofence?.fenceName ? row.geofence?.fenceName : 'null' }}
                          </h5>
                          <span class="teal-200"
                            >{{ row.totalVehicle }} {{ $t('global.object.fleet') }}</span
                          >
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-skeleton-wrapper>

        <ServiceScheduler
          v-if="layout.key == 'serviceScheduler' && hasAccessAll(['maintenance:read'])"
          ref="serviceScheduler"
        />
        <!-- The scope for ServiceScheduler was not determined but this scope is used for temporary as to handle urgent bug founded. -->
      </b-col>
    </draggable>

    <ModalFleets v-if="modalVehicleStatus" :items="items" :vehicleStatusType="vehicleStatusType" />

    <ModalGeofence
      v-if="isOpenModalModalPool"
      :data="modalGeofenceData.data"
      :label="modalGeofenceData.label"
      :type="modalGeofenceData.type"
    />
  </div>
</template>
<style scoped>
.limited-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
</style>
